import styled from 'styled-components';
import { Image } from '../image';

const ImageError = styled(Image)`
  img {
    @media (max-width: 768px) {
      width: 100%;
      padding: 0 8px;
    }
  }
`;
const BoxMain = styled.div`
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export { ImageError, BoxMain };
